import React from 'react';
import { formatCurrency } from '../../utils/currency';

interface OrderTotalsMarketplaceProps {
  order: any;
}

export const OrderTotalsMarketplace: React.FC<OrderTotalsMarketplaceProps> = ({ order }) => {
  return (
    <div className="bg-gray-50 p-6 rounded-lg space-y-4">
      <div className="flex justify-between text-sm">
        <span>Subtotal</span>
        <span>{formatCurrency(order.subtotal)}</span>
      </div>
      
      {order.shippingCost > 0 && (
        <div className="flex justify-between text-sm">
          <span>Portes de Envio</span>
          <span>{formatCurrency(order.shippingCost)}</span>
        </div>
      )}

      <div className="flex justify-between text-sm">
        <span>Total</span>
        <span className="font-semibold">{formatCurrency(order.total)}</span>
      </div>
    </div>
  );
};
